import type { Dependencies } from "@redux/store";
import { createAction, createAsyncThunk } from "@reduxjs/toolkit";
import type { RejectExternalProviderBatchRequestBody } from "@shared-kernel/application/ports/admin/admin-repository";

export const rejectExternalProviderBatchRequest = createAsyncThunk<
  void,
  RejectExternalProviderBatchRequestBody,
  { extra: Partial<Dependencies> }
>(
  "externalProviderBatchRequests/rejectExternalProviderBatchRequest",
  async (body: RejectExternalProviderBatchRequestBody, { extra: { adminRepository } }) => {
    return adminRepository!.rejectExternalProviderBatchRequest(body);
  },
);

export const resetRejectExternalProviderBatchRequest = createAction(
  "externalProviderBatchRequests/resetRejectExternalProviderBatchRequest",
);
